import { StyleSheet } from 'aphrodite/no-important';

import colors from '../../identity/colors';
import typeContent from '../../identity/type';
import spacing from '../../identity/spacing';
import screens from '../../identity/screenSizes';

export default StyleSheet.create({
  container: {
    backgroundColor: colors.BLUE_PRIMARY,
    padding: spacing.DESKTOP_T_R_L,
    paddingBottom: '120px',

    [screens.TABLET]: { padding: spacing.MOBILE_V_H },
    [screens.DESKTOP_HD]: { padding: '132px 66px' },
    [screens.MOBILE]: { padding: '108px 16px' },

  },

  paragraph: { 
    ...typeContent.H1,
    maxWidth: '1100px',
    fontWeight: 300,
    lineHeight: typeContent.H2.lineHeight,
    color: colors.WHITE,
    margin: 0,
 
    [screens.INTRO_1]: { margin: '0 30px' },
    [screens.INTRO_2]: { margin: '0 60px' },
    [screens.INTRO_3]: { margin: '0 120px' },
    [screens.INTRO_4]: { margin: '0 240px' },
    [screens.INTRO_5]: { margin: '0 480px' },


    [screens.MOBILE]: { fontSize: 24, marginBottom: 0 },
    [screens.DESKTOP_HD]: { marginBottom: 0 },
  },

});



// WEBPACK FOOTER //
// ./src/components/IntroText/style.js